export const productFiltersNames = {
  initialProductPeriod: 'Initial product period',
  rateType: 'Rate type',
};
